import { render, staticRenderFns } from "./WatermarkDialog.vue?vue&type=template&id=24f474ec&scoped=true&"
import script from "./WatermarkDialog.vue?vue&type=script&lang=ts&"
export * from "./WatermarkDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WatermarkDialog.vue?vue&type=style&index=0&id=24f474ec&prod&lang=css&"
import style1 from "./WatermarkDialog.vue?vue&type=style&index=1&id=24f474ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f474ec",
  null
  
)

export default component.exports